
const digest = '45d44f460e0ce712b343b64020e2a619ae77db1390e69e217cdb6f74608b54be';
const classes = {"wrapper":"_wrapper_15bq2_1"};
const css = `._wrapper_15bq2_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  